module.exports = __webpack_public_path__ + "static/Verne3-deb343094566eb2e45956bdf3040a466.png";